import { OptionsTranslations } from "./optionsTranslations.types";

import {
    getCgvLink,
    getDataRightsLink,
    getPrivacyPolicyLink,
} from "@/service/legalLinks/legalLinksService";

const cgvUrl = getCgvLink();
const dataRightsLink = getDataRightsLink("en");
const privacyPolicyLink = getPrivacyPolicyLink("en");

const optionsUkTranslations: OptionsTranslations = {
    optionsPage: {
        "title": "Extras",
        "step": "Step",
        "optionsExtraTitle": "Customize your trip",
        optionsChangeModalErrorAgeChange: "There has been a change to an aspect of your selected flight (price and/or availability). Please re-confirm your flight selection.",
        optionsChangeModalContinue: "Continue",
        invalidLastNameError: 'Please enter a valid last name, at least 2 characters',
        invalidDateError: 'Please enter your birth date',
        invalidFirstNameError: 'Please enter a valid first name, at least 2 characters',
        hasFirstParticipantToBeAdultError: 'First participant has to be an adult',
        hasToBeAdultError: 'Participant has to be an adult',
        accommodationExceedsAdultsError: 'The number of accommodations selected cannot exceed the number of adults in your group. Please modify the birth dates accordingly.',
        accommodationCount: 'Number of accommodations',
        adultCount: 'Number of adults',
        invalidParticipantError: "Please fill in this participant's information",
        optionsModify: "Customize",
        optionsModifyPanel: "Modify",
        optionsPanelTitleModify: "Modify the",
        optionsPanelTitleModifyLa: "Modify the",
        optionsPanelTitleModifyFor1: "Modify the",
        optionsPanelTitleModifyFor2: "of",
        optionsAdd: "Add",
        optionsIncluded: "Included",
        optionsDay: "day",
        optionsDays: "days",
        optionsDays2: "days",
        optionsFrom: "from",
        optionsTo: "to",
        optionsValidateSelection: "Validate my selection",
        validateForAllParticipants: "Validate my selection for all participants",
        optionsRemoved: "removed from the package",
        optionsErrorSorry: "Sorry,",
        optionsErrorDefaultService: "this service",
        optionsErrorNotAvailable: "is no longer available.",
        optionsNoServiceSelected: "No service selected",
        optionsNoServiceSelected1: "",
        optionsNoServiceSelected2: "",
        optionsNoSkipass: "No ski pass selected",
        optionsNoEquipment: "No equipment selected",
        optionsNoTransport: "No transport  options selected",
        optionsNoEsf: "No ski school selected",
        optionsVirtualNoEsf: "No ski school",
        optionsEsfOneLesson: "1 ski lesson selected",
        optionsEsfLessonsCount: "{count} ski lessons selected",
        optionsEsfLoading: "Loading ski lessons…",
        optionsEsfConfigured: "Lesson configured",
        optionsEsfProgress: "{done}/{total} lessons configured",
        optionsEsfPanelTitle: "ESF ski lessons",
        optionsEsfParticipantIncomplete: "Complete participant profile",
        optionsEsfAlreadyConfigured: "This participant already has a lesson configured.",
        optionsEsfModify: "Modify",
        optionsEsfRemove: "Remove",
        optionsEsfRemoveFailed: "Could not remove the lesson.",
        optionsNoFood: "No food pack selected",
        optionsNoInsuranceSkier: "No insurance selected",
        optionsNoHotelService: "No hotel options selected",
        options15Cancellation: "Included: Free cancellation up to 15 days before the stay",
        options45Cancellation: "Free 100% cancellation up to 40 days before arrival*",
        options45CancellationUnderSentence: "*More informations in our T&C",
        optionsWhoDeparts: "Participants",
        optionsPleaseFillParticipants: "Please enter the surnames, first name and ages of each person on the booking at the start of the holiday.",
        widgetAllParticipantsRequired: "Please save every participant (Save on each card) before continuing.",
        widgetContactInvalid: "Please enter a valid email address and phone number.",
        widgetRegisterFailed: "Could not create your account with these details. Try again or use a different email.",
        widgetTransportConfigureTitle: "Set up your transport",
        widgetJourneyDetailsTitle: "Trip details",
        widgetOrderRecapTitle: "Order summary",
        widgetTrainOutboundColumn: "Outbound train",
        widgetTrainReturnColumn: "Return train",
        widgetNoReturnTrain: "—",
        widgetTransferToStation: "Transfer to {station}",
        widgetTransferFromStation: "Transfer from {station}",
        optionsFillNames: "Please fill in the surnames, first name and ages of each person to benefit from the best prices.",
        optionsParticipant: "Participant",
        optionsYears: "years",
        optionsYearsAndMore: "more",
        optionsAgeAtStart: "Age at the beginning of the holiday",
        optionsFirstName: "First name",
        optionsLastName: "Surname",
        optionsTravelersErrorMessage: "Please fill in the surname, first name and ages of each person on the booking",
        optionsPrepareYourVoyage: "Personalise your holiday",
        optionsSelectYourInsurances: "Select your insurance options",
        optionsChangeTravelerAge: "Changing the age of the participant will reset all of his/her options.",
        optionsChangeTravelerAgeConfirmation: "The age of the following participants has been updated. All their options have been reset.",
        optionsChangeTravelerAgeUpdated: "Participant information has been updated",
        optionsIUnderstood: "I understand",
        optionsSkipass: "Ski pass",
        optionsNoSkipassSelected: "No ski pass selected",
        optionsKmSkiSlopes: "km of pistes",
        optionsOfTracks: "pistes",
        optionsRemoveSkipass1: "If you remove this option from your package, an amount of",
        optionsRemoveSkipass2: "will be kept",
        optionsNoQueues: "The ski pass is delivered at the same time as the keys on arrival",
        optionsSkipassBlueSentence: "Save time and money",
        optionsEquipment: "Ski equipment",
        optionsSelectLevel: "Select your range",
        criteria997: "Eco",
        criteria998: "Silver",
        criteria999: "Golden",
        criteria1000: "Platinium",
        criteria1031: "Rookie",
        criteria1030: "Champion",
        optionsNoEquipmentSelected: "No equipment selected",
        optionsEnjoySkiingAtArrival1: "Collect your equipment from the shop",
        optionsEnjoySkiingAtArrival2: "which is located at",
        optionsEnjoySkiingAtArrival3: "metres from your accommodation",
        optionsHelmet: "Helmet",
        optionsShoes: "Ski boots",
        optionsSticks: "Poles",
        optionsEquipmentBlueSentence: "Be close and calm",
        optionsTransport: "Transport",
        optionsTransfer: "Transfer",
        optionsEnjoySkiingAtArrival: "Benefit from skiing on arrival",
        optionsDistanceFromSkiShop1: "The skishop",
        optionsDistanceFromSkiShop2: "is located",
        optionsDistanceFromSkiShop3: "from your accommodation",
        optionsDistanceFromSkiShop4: "is located in the same building as your accommodation!",
        optionsPickupEquipmentAtShop: "Pick up your equipment at the shop",
        optionsAddTransport: "Add transport",
        optionsAddTransportFor: "Add transport for",
        optionsDeleteTransport: "Remove the transport",
        optionsTransportFirstDate: "Outbound",
        optionsTransportSecondDate: "Return",
        optionsPackageTravelski: "Travelski package",
        optionsTrainPlusShuttle: "Train and transfer. No need to worry on your family ski holiday",
        optionsNoTransportSelected: "No transport  options selected",
        optionsChooseAGo: "Choose your outbound",
        optionsChooseAReturn: "Choose your return",
        optionsDeparture: "Departure",
        optionsReturn: "Return",
        optionsDepartureStation: "Departure point",
        optionsArrivalStation: "Arrival point",
        optionsOneWayOption: "Options",
        optionsITravelIn: "I travel in:",
        optionsMyTransfer: "My transfer",
        optionsTransportSummaryFor: "Transport summary for",
        optionsTotalTransport: "Total for transport",
        optionsTransitTime: "transfer time",
        optionsEstimatedTime: "Estimated at",
        optionsInformation: "Information",
        train: "train",
        criteria1039: "1st class",
        criteria1040: "2nd class",
        shuttle: "Shuttle",
        taxi: "Taxi",
        baggageCabin: "Hand luggage",
        backpack: "Backpack",
        wifi: "Wifi",
        meal: "Meal",
        dinner: "Dinner",
        optionsHowToChooseTitle: "How do I choose a course suited to my skiing level?",
        optionsSkiLesson: "Ski school",
        optionsTakeEsf: "Select a course",
        optionsCourseOn: "Course on",
        optionsHowIChooseLesson: "Choose a course suitable for your ski ability",
        optionsBeginner: "Beginner",
        optionsPiouPiou: "Piou-Piou",
        criteria992: "Ourson",
        criteria993: "Flocon",
        criteria994: "1st star",
        criteria995: "2 star",
        criteria996: "3 star",
        criteria1058: "Level 0",
        criteria1059: "Level 1",
        criteria1060: "Level 2",
        criteria1061: "Level 3",
        criteria1062: "Level 4",
        criteria1063: "Level 5",
        criteria1064: "Ski",
        criteria1065: "Snowboard",
        optionsSkiTab: "Ski",
        optionsSnowboardTab: "Snowboard",
        optionsNoCourseSelected: "No skischool selected",
        optionsContentPiouPiou: "I will be  trying skiing for the first time",
        optionsContentOursonTitle: "I have never skiied",
        optionsContentOurson: "I want to command the snowplogh and make my first turns",
        optionsContentFloconTitle: "I have my level Ourson",
        optionsContentFlocon: "I feel like hitting the slopes and making big turns faster.",
        optionsContent1StarTitle: "I have my level flocun",
        optionsContent1Star: "I can turn in snowplogh and take the ski lift on my own",
        optionsContent2StarTitle: "I have 1st star and can ski at ease on the green slopes",
        optionsContent2Star: "I need to master parellel so I can ski the steeper slopes",
        optionsContent3StarTitle: "I have passed my 2 star",
        optionsContent3Star: "I need top perfect my parellel turn and sliding so I can ski faster",
        optionsContentAdulteBeginnerTitle: "I do not ski",
        optionsContentAdulteBeginner: "I need to learn to stay upright, control my speed, make snowplogh turns and use the lifts",
        optionsAdultsBeginner: "Adults - beginners",
        optionsWatchVideo: "See the video",
        optionsBackToChoices: "Return to the choices",
        optionsAgeGroup1: "3 to 4 years old",
        optionsAgeGroup2: "4 to 5 years old",
        optionsAgeGroup3: "6 to 12 years old",
        optionsAgeGroup4: "13 years and older (Adults)",
        optionsFood: "Food Pack delivery",
        optionsTakeFood: "",
        optionsTakeFoodFor: "",
        optionsCatering: "",
        optionsCateringDelivery: "",
        optionsNoFoodSelected: "",
        optionsSeeMenu: "See the menu",
        optionsRestaurant: "Restaurant & Board",
        optionsCateringServices: "Catering services to suit your tastes",
        optionsRestaurationBord: "Onboard catering",
        optionsRestaurationBordOutbound: "Onboard catering - Outbound",
        optionsRestaurationBordInbound: "Onboard catering - Return",
        optionsFacilitateArrival: "Facilitate your arrival by booking your services",
        optionsReserveYourServices: "Book your services",
        optionsTakeAccommodationServices: "Select your hotel options",
        optionsBookServices: "Book your options",
        optionsBookServicesEasy: "Prebook your options to ease  the arrival process",
        optionsInsurance: "Insurance",
        optionsTakeInsurance: "Select the ski insurance",
        optionsNoInsuranceSelected: "No insurance selected",
        optionsInsuranceAdvantages: "The advantages of ski insurance",
        optionsPerPers: "person",
        optionsBreakageTheft: "Breakage and theft of personal or rental ski equipment",
        optionsRescueResearch: "Costs of search and rescue on the slopes",
        optionsHospitalization: "Medical and hospital expenses (excluding social security)",
        optionsRepatriation: "Repatriation costs",
        optionsInterruptionStay: "Costs for interruption of the stay and refunds for unused services",
        optionsSnowGuarantee: "Snow guarantee",
        optionsInsuranceAnnulation: "Cancellation Insurance",
        optionsPerBooking: "Booking",
        optionsCancellation: "Cancellation possible until the day before departure",
        optionsReimbursement: "Refund by bank transfer for justified reasons",
        optionsCreditNote: "Covers cases excluded by credit cards",
        optionsCoveragePrice: "Voucher valid for 12 months in case of unjustified reason",
        optionsInsuranceAnnulationNo: "I do not opt for the insurance",
        optionsInsuranceAnnulationYes: "I opt for the insurance",
        optionsInsuranceSlogan: "Covered during the stay",
        optionsPerson: "adult",
        optionsFree: "Free",
        commercialDiscount: "Commercial discount",
        moreInfos: "More information",
        seeLess: "Close",
        saveRegistration: "Save",
        acceptConditions: "I have read and accept the General Terms and Conditions of Sale and the Personal Data Management Policy.",
        optionSumbit: "Book",
        yes: "Yes",
        no: "No",
        "optionsInsuranceAnnulationCallToAction": "Would you like to purchase cancellation insurance?",
        optionsSkiSchool: 'Ski school',
        optionsSkiInsurance: 'Skier Insurance',
        enterPromocode: "Enter your promotion code",
        promocode: "Promotion code",
        promocodeWrong: "The promotional code that you have used is not valid",
        promocodeApplied: "Promotional code applied successfully",
        promocodeEmailRequired: "Email is required to use this promotional code",
        promocodeEmailModalTitle: "Enter your email",
        promocodeEmailPlaceholder: "Your email address",
        promocodeEmailSubmit: "Submit",
        promocodeEmailCancel: "Cancel",
        promocodeEmailInvalid: "Invalid email format",
        promocodeRemoved: "Your promotional code was removed",
        promocodeExternalValidationTitle: "External Validation Required",
        promocodeExternalValidationProvider: "Provider",
        promocodeExternalValidationCancel: "Cancel",
        promocodeExternalValidationSubmit: "Submit",
        promocodeExternalValidationFieldFirstname: "First name",
        promocodeExternalValidationFieldLastname: "Last name",
        promocodeExternalValidationFieldBirthdate: "Date of birth",
        promocodeExternalValidationFieldLastSixDigits: "Last 6 digits",
        promocodeExternalValidationFieldRequired: "{{label}} is required",
        promocodeExternalValidationFieldInvalidFormat: "{{label}} format is invalid",
        promocodePrivateWarningTitle: "ATTENTION: This promo code is private",
        promocodeDeleteCode: "I remove my code",
        promocodeValidate: "I validate",
        promocodePrivateWarningProof: "Attention, a **proof of membership** for [CSE NAME] may be requested upon your arrival.",
        promocodeWarningTitle: "Attention",
        removePromocode: "Remove the code",
        optionFlightLuggage: "Flight luggage",
        optionsFlightLuggageHoldBag: "Additional luggage",
        optionsFlightLuggageUnderSeatBag: "Under-seat bag",
        optionsFlightLuggageUnderSeatBagInfo: "Your booking includes one under-seat bag.",
        optionsFlightLuggageUnderSeatBagInfoMaxSize: "Maximum size: 40x30x20 cm",
        optionsFlightAdditionalLuggage: "Additional luggage",
        optionsLuggagePopupTitle: "Are you traveling without luggage?",
        optionsLuggagePopupDescription: "It looks like you haven't added any luggage to your booking. For a flight package, this might be inconvenient.\n\nWould you like to continue without luggage or add some now?",
        optionsLuggagePopupNoLuggage: "I don't want any luggage",
        optionsLuggagePopupAddLuggage: "I want to add luggage",
        optionParking: "Parking",
        optionsParkingDefault: "Parking space",
        optionsChangeModalTitle: "Option changes",
        optionsChangeModalDescription: "Due to age changes of one of the participants, the prices and availability of certain options have changed. Here are the changes.",
        optionsChangeModalSubtitle: "Options changed due to age changes",
        optionsChangeModalTotalDifference: "Total difference:",
        optionsChangeModalDismiss: "Dismiss",
        optionsChangeModalNoChange: "No change",
        optionsChangeModalNotAvailable: "Not Available",
        optionsChangeModalOption: "Option",
        optionsChangeModalChangesAgeFrom: "changes age from",
        optionsChangeModalTo: "to",
        optionsChangeModalTraveller: "Traveller",
        // Transport cabin translations
        transportSharedCabinTitle: "Individual berths",
        transportSharedCabinDescription: "Experience a unique journey in a cabin.",
        transportPrivateCabinTitleSingle: "Private compartment 6 berths",
        transportPrivateCabinTitlePlural: "Private compartments 6 berths",
        transportPrivateCabinDescription: "Book an entire compartment, alone or with others, for your family or friends trip.",
        transportDetailBannerDescription: "Our compartments are made up of 6 berths to guarantee you a night's rest.",
        transportDetailBannerDetails: "Details",
        transportDetailSharedCabinDescription: "Each compartment is designed as a warm, intimate and comfortable space where families and friends meet to share, exchange and dream together about the moments that await them.",
        transportDetailSharedCabinFooterTitle: "Travel with women only",
        transportDetailSharedCabinFooterDescription: "We have provided a 100% female space for a peaceful journey.",
        transportDetailPrivateCabinDescription: "The compartments can be privatized, whether for families, groups or according to essential preferences for a peaceful journey.",
        transportCriteriaWifi: "Free Wi-fi",
        transportCriteriaBar: "Bar carriage",
        transportCriteriaOutlet: "Power outlet",
        transportCriteriaPillow: "Sheet, sleeping bag, pillowcase and blanket provided.",
        transportCriteriaComfortPouch: "Comfort pouch (refreshing wipes, earplugs, tissues)",
        transportCriteriaPrivateSpace: "Private space",
        transportCriteriaPlaces: "6 berth places",
        transportOnlyWomenTitle: "Women-only space (free)",
        transportOnlyWomenDescription: "A space reserved for women to travel at night in complete tranquility.",
        transportPreferencesAvailabilityNotice: "*Your preferences will be taken into account depending on availability",
        transportFullTimelineTitle: "Journey details",
        transportDetailPanelTitle: "A comfortable journey",
        optionsTrainOnly: "Train",
        // Transfer translations
        unicular: "Funicular",
        transferBusDescription: "A shared shuttle with fixed times and multiple stops. Bus changes or walking may be needed.",
        transferBusLesArcsTitle: "Bus + Funiculaire",
        transferBusLesArcsDescription: "The journey takes place in two stages: bus to Bourg-Saint-Maurice, then funicular to Les Arcs.",
        transferTaxiDescription: "Private transfer with a dedicated driver for your exclusive use.",
        transferUnicularDescription: "Reach Les Arcs easily thanks to the ultramodern funicular, which connects Bourg-Saint-Maurice station to Les Arcs 1600 station in just 7 minutes.",
        transferCriteriaDuration: "Estimated transfer time:",
        transferCriteriaWalking: "May require bus changes en route or walking to your stay.",
        transferUnicularCriteriaWalking: "At the funicular arrival station, you will find shuttles to other Les Arcs stations (Les Arcs 1800, Les Arcs 1950 and Les Arcs 2000)",
        transferCriteriaDoorToDoor: "Door-to-door service",
        transferAlps2AlpsStandardTaxiTitle: "Standard Taxi",
        transferAlps2AlpsStandardTaxiDescription: "A transfer suited for travelers alone or small families traveling without ski equipment.",
        transferAlps2AlpsMinivan7Title: "Minivan – 7 seats",
        transferAlps2AlpsMinivan7Description: "A spacious vehicle, perfect for families and small groups traveling with luggage and ski equipment.",
        transferAlps2AlpsMinivan16Title: "Minivan – 16 seats",
        transferAlps2AlpsMinivan16Description: "The ideal solution for traveling together while simplifying the organization of large groups.",
        transferAlps2AlpsSharedTaxiTitle: "Shared Taxi",
        transferAlps2AlpsSharedTaxiDescription: "An economical and environmentally friendly option to reach your station by sharing your trip with other travelers.",
        transferAlps2AlpsUpToPassengers: "Up to {count} passengers",
        transferAlps2AlpsEstimatedTravelTime: "Estimated travel time:",
        transferAlps2AlpsDoorToDoor: "Door-to-door service",
    },
    "optin": {
        "common": {
            "seeMore": "See more",
            "seeLess": "See less",
            "clickHere": "Click here",
            "reserve": "Reserve"
        },
        "terms": {
            "label": `I have read and accept the <a href='${cgvUrl}' target='_blank'><strong>General Terms and Conditions of Sale</strong></a>, the information documents, the general and special terms and conditions of sale for insurance and the <a href='${privacyPolicyLink}' target='_blank'><strong>Personal Data Management Policy</strong></a>.`,
            "short": "The data collected is processed by Travelfactory, the company responsible for data processing, whose head office is located at 19 rue Emmy Noether, 93400 Saint-Ouen, France. <br/>",
            "full": `This data is essential for managing your reservation and concluding the related contract. It will be included in Travelfactory's database and will also be used to send you information and advertising on similar products and services, notably on the basis of our legitimate interests and the legal provisions on canvassing. You have the right to access your data, which you can exercise via our contact form available <a href='${dataRightsLink}' target='_blank'>here</a>. To find out more about how we process your data, please consult our <a href='${privacyPolicyLink}' target='_blank'>privacy policy</a>. You can also unsubscribe at any time via a link in electronic newsletters, or by e-mail.`
        },
        "description": {
            "short": "If you do not wish to receive communications from us, simply <span class='underline'>click here</span>.",
            "email": "Email",
            "sms": "SMS",
            "note": "If you uncheck the boxes, you object to receiving commercial communications. You may still receive communications that are strictly necessary to complete your stay (e.g. booking confirmation, payment reminder)."
        }
    },
    "food": {
        "foodImageCriteria1025": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_new.jpg",
        "foodImageCriteria1025Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_mobile_new.jpg",
        "foodImageCriteria10241025": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_halal_new.jpg",
        "foodImageCriteria10241025Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_halal_mobile_new.jpg",
        "foodImageCriteria1023": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_new.jpg",
        "foodImageCriteria1023Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_mobile_new.jpg",
        "foodImageCriteria1024": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal.jpg",
        "foodImageCriteria1024Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal_mobile_new.jpg",
        "foodImageCriteria10231024": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal.jpg",
        "foodImageCriteria10231024Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal_mobile_new.jpg",
        "foodImageCriteria1021": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gastronomique_new.jpg",
        "foodImageCriteria1021Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gastronomique_mobile.jpg",
        "foodImageCriteria1067": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_petit_dejeuner.png",
        "foodImageCriteria1067Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_petit_dejeuner_mobile.png",
        "foodImageCriteria1069": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_demi_pension.png",
        "foodImageCriteria1069Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_demi_pension_mobile.png",
        "foodImageCriteria1071": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course dinner menu 6 days_desktop.png",
        "foodImageCriteria1071Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course dinner menu 6 days_mobile.png",
        "foodImageCriteria1072": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course vegetarian menu 3 days Desktop.png",
        "foodImageCriteria1072Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course vegetarian menu 3 days Mobile.png",
        "foodImageCriteria1073": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course vegetarian menu 6 days Desktop.png",
        "foodImageCriteria1073Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course vegetarian menu 6 days Mobile.png",
        "foodImageCriteria1074": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/vegan dinner only 3 days_desktop.png",
        "foodImageCriteria1074Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/vegan dinner only menu 3 days_mobile.png",
        "foodImageCriteria1075": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/vegan dinner only 6 days_desktop.png",
        "foodImageCriteria1075Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/vegan dinner only menu 6 days_mobile.png",
        "foodImageCriteria1076": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Kids menu 3 days_desktop.png",
        "foodImageCriteria1076Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Kids menu 3 days_mobile.png",
        "foodImageCriteria1077": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Kids menu 6 days_desktop.png",
        "foodImageCriteria1077Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Kids menu 6 days_mobile.png",
        "foodImageCriteria1078": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course dinner menu 3 days_desktop.png",
        "foodImageCriteria1078Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course dinner menu 3 days_mobile.png"
    }
    ,
    "globalInsuranceConditions": "View insurance conditions"

};


export default optionsUkTranslations;